import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeCtrLink extends ChangeBusinessDetails {
  type: string = 'ChangeCtrLink';
}
